import { Menu as AntMenu } from 'antd'
import styled from 'styled-components'
import { color, padding } from 'theme/mixins'

const Menu = styled(AntMenu)`
	display: flex;
	flex-direction: column;
	flex: 1;
	padding-bottom: ${padding('sm')} !important;

	.__remarkable {
		background: ${color(['warning', '000'])};
		color: ${color(['warning', '500'])};
	}

	li:last-child {
		margin-top: auto !important;
	}
`

export default { Menu }
